<template>

    <button type="button" role="menuitem" class="adm-menu__item" :class="itemClasses" :disabled="disabled">
        <i v-if="icon" :class="icon" aria-hidden="true"></i>
        <span>{{ text }}</span>
    </button>

</template>

<script>
/**
 * Item do menu de ações ("⋮") das tabelas do admin.
 *
 * É um `<button>` de verdade: recebe foco pelo teclado, aceita `disabled`
 * nativo e o `@click` do pai chega pelo fallthrough de atributos, como antes.
 * A aparência (incluindo as variantes de cor) mora em `assets/css/admin.css`,
 * seção "Menu de ações", para o item sair idêntico em todas as páginas.
 */
export default {
    name:'OptionActionDataTable',
    props: {
        text: {
            type: String
        },
        icon: {
            type: String
        },
        /** `primary` | `secondary` | `info` | `success` | `warning` | `danger` | `light` */
        textColor:{
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        itemClasses() {
            const tons = ['primary', 'secondary', 'info', 'success', 'warning', 'danger', 'light'];
            return tons.includes(this.textColor) ? `adm-menu__item--${this.textColor}` : '';
        },
    }
}
</script>
